// import React from "react";
// import { IoAdd } from "react-icons/io5";
// import WorkTypeList from "../WorkType/list.js";
// import WorkTypeForm from "../WorkType/form.js";
// import { NavLink, useNavigate, useParams } from "react-router-dom";
// import { hasPermission } from "../../../../utils/permission.js";

// const PlusIcon = () => <IoAdd className="icon" aria-hidden="true" />;

// function WorkType() {
//   const listPermission = hasPermission("work-types", "view");
//   return (
//     <div className="projects-page">
//       <header className="page-header-projects">
//         <div className="header-text-content">
//           <h1>Work Types</h1>
//           <p>View and manage all company work orders.</p>
//         </div>
//         {hasPermission("work-types", "create") && (
//           <NavLink to="/work-types/new">
//             <button className="create-project-button-header">
//               <PlusIcon /> Create New Work Type
//             </button>
//           </NavLink>
//         )}
//       </header>
//       {listPermission ? (
//         <WorkTypeList />
//       ) : (
//         <>You do not have permission to view this.</>
//       )}
//     </div>
//   );
// }

// export const WorkTypeFormPage = () => {
//   const navigate = useNavigate();
//   let { id } = useParams();
//   const createPermission = hasPermission("work-types", "create");
//   const updatePermission = hasPermission("work-types", "set");
//   if (id == "new") {
//     if (!createPermission) {
//       alert("You do not have permission to view this page.");
//       navigate("/work-types");
//       return null;
//     }
//     id = null;
//   } else {
//     if (!updatePermission) {
//       alert("You do not have permission to view this page.");
//       navigate("/work-types");
//       return null;
//     }
//   }
//   return (
//     <div className="projects-page">
//       <NavLink to="/work-types">
//         <button className="backbutton">Back To Work Types</button>
//       </NavLink>
//       <WorkTypeForm workOrderId={id} />
//     </div>
//   );
// };

// export default WorkType;



import React from "react";
import { IoAdd } from "react-icons/io5";
import WorkTypeList from "../WorkType/list.js";
import WorkTypeForm from "../WorkType/form.js";
import { NavLink, useParams } from "react-router-dom";
import { hasPermission } from "../../../../utils/permission.js";
import { AccessDenied } from "../../../../shared-ui/States";

const PlusIcon = () => <IoAdd className="icon" aria-hidden="true" />;

function WorkType() {
  const listPermission = hasPermission("work-types", "view");
  return (
    <div className="projects-page">
      <header className="page-header-projects">
        <div className="header-text-content">
          <h1>Work Types</h1>
          <p>View and manage all company work types.</p>
        </div>
        {hasPermission("work-types", "create") && (
          // --- FIX: Added '/organization' prefix ---
          <NavLink to="/organization/work-types/new">
            <button className="create-project-button-header">
              <PlusIcon /> Create New Work Type
            </button>
          </NavLink>
        )}
      </header>
      {listPermission ? (
        <WorkTypeList />
      ) : (
        <AccessDenied description="You do not have permission to view this." />
      )}
    </div>
  );
}

export const WorkTypeFormPage = () => {
  // --- FIX: Use `rowId` to match the parameter name in App.js ---
  let { rowId } = useParams();
  const createPermission = hasPermission("work-types", "create");
  const updatePermission = hasPermission("work-types", "set");
  
  // --- FIX: Define base path for reuse and correctness ---
  const basePath = "/organization/work-types";

  if (rowId === "new") {
    if (!createPermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
    rowId = null; // Set to null for create mode
  } else {
    if (!updatePermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
  }

  return (
    <div className="projects-page">
      {/* --- FIX: Added '/organization' prefix --- */}
      <NavLink to={basePath}>
        <button className="backbutton">Back To Work Types</button>
      </NavLink>
      {/* --- FIX: Pass prop consistently as workTypeId --- */}
      <WorkTypeForm workTypeId={rowId} />
    </div>
  );
};

export default WorkType;